import { render, staticRenderFns } from "./EditCommunitySpace.vue?vue&type=template&id=27f3b4d0"
import script from "./EditCommunitySpace.vue?vue&type=script&lang=js"
export * from "./EditCommunitySpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports